"use client";

import { brandLegal } from "@calcom/features/teams/lib/brandLegal";
import { brandBySlug, BRAND_SKINS } from "@calcom/features/teams/lib/brandSkins";
import { usePathname } from "next/navigation";
import { useLayoutEffect } from "react";

/**
 * 404 aux couleurs de la marque, en français.
 * Remplace la 404 de cal.diy (Documentation, Blog, « username still available », retour vers cal.com).
 * Sans marque connue (hôte technique) : Café Crème Club.
 */
export function NotFound({ brandSlug }: { host?: string; brandSlug?: string | null }) {
  const pathname = usePathname() ?? "";
  const skin = brandBySlug(brandSlug) ?? BRAND_SKINS["cafe-creme-club"];
  const legal = brandLegal(skin);
  const isBookingPage = pathname.startsWith("/booking");

  useLayoutEffect(() => {
    if (typeof window !== "undefined") {
      window.CalComPageStatus = "404";
    }
  }, []);

  return (
    <div
      className="min-h-screen bg-[#F4F4F5] px-4 py-10 sm:px-8 sm:py-16"
      style={{ color: skin.ink }}
      data-testid="brand-not-found"
      data-brand={skin.slug}>
      <div className="mx-auto w-full max-w-xl rounded-2xl bg-white px-6 py-10 text-center shadow-sm sm:px-10">
        <img
          src={skin.markUrl}
          alt={skin.name}
          width={56}
          height={56}
          className="mx-auto h-14 w-14"
          data-testid="brand-logo"
        />
        <p className="mt-6 text-sm font-semibold uppercase tracking-wide text-[#6B7280]">Erreur 404</p>
        <h1 className="mt-2 text-2xl font-semibold text-[#1C1A17] sm:text-3xl">
          {isBookingPage ? "Ce rendez-vous est introuvable." : "Cette page n'existe pas."}
        </h1>
        <p className="mx-auto mt-3 max-w-md text-base text-[#4B5563]">
          {isBookingPage
            ? "Le lien est incomplet ou le rendez-vous a été supprimé. Vous pouvez en reprendre un en quelques clics."
            : "Le lien est peut-être incomplet, ou la page a été déplacée."}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="/"
            className="inline-flex w-full items-center justify-center rounded-lg px-5 py-2.5 text-sm font-medium sm:w-auto"
            style={{ backgroundColor: skin.bookerColor, color: "#FFFFFF" }}>
            Prendre rendez-vous
          </a>
          <a
            href={legal.siteUrl}
            className="inline-flex w-full items-center justify-center rounded-lg border border-[#E5E7EB] px-5 py-2.5 text-sm font-medium text-[#1C1A17] sm:w-auto">
            Aller sur le site {skin.name}
          </a>
        </div>
      </div>
    </div>
  );
}
